'use strict';

export default function ($stateProvider, $urlRouterProvider) {
  'ngInject';

  $urlRouterProvider.when("/monitor", "/monitor/list");

  $stateProvider
    .state('monitor', {
      url: '/monitor',
      template: require('./monitor.html'),
      authenticate: true
    })
    .state('monitor.list', {
      url: '/list',
      template: require('./list/list.html'),
      controller: 'MonitorListController',
      controllerAs: 'monitorListCtrl'
    })
    .state('monitor.add', {
      url: '/add',
      template: require('./add/add.html'),
      controller: 'MonitorAddController',
      controllerAs: 'monitorAddCtrl'
    })
    .state('monitor.edit', {
      url: '/edit/:id',
      template: require('./edit/edit.html'),
      controller: 'MonitorEditController',
      controllerAs: 'monitorEditCtrl'
    });
}



// WEBPACK FOOTER //
// ./client/app/monitor/monitor.routes.js